module.exports = __webpack_public_path__ + "fonts/SFUIText-Medium.d0253f29.ttf";